/** @jsx jsx */

import { Alert as DSAlert, AlertDescription } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { useDismissable } from 'app/developer-v3/hooks';

const PERSIST_ID = 'developer-create-integration-version-caveat';

const Styles = {
  root: css`
    margin: 0 0 20px;
  `,
};

function Alert() {
  const { dismiss, isVisible } = useDismissable({ persistId: PERSIST_ID });

  return (
    isVisible && (
      <div css={Styles.root}>
        <DSAlert
          onDismiss={dismiss}
          status="warning"
          title="Trying to update an existing integration?"
        >
          <AlertDescription>
            If so, you don't have to create a new integration. Go to the
            Versions page of the integration you would like to update and follow
            the{' '}
            <Link href={`${BASE_DOC_URL_VB}/manage/versions`} target="_blank">
              provided guidance
            </Link>
            .
          </AlertDescription>
        </DSAlert>
      </div>
    )
  );
}

export default Alert;
